import React, { useEffect, useRef, useState } from 'react';
import delay from './delay.png';
export interface PlayerProps {
  videoUrl: string;
  handleRecordDelayValue: AnyFunc;
  direction: string;
  maxDelay?: number;
}
const RtcPlayer = (props: PlayerProps) => {
  const { videoUrl, handleRecordDelayValue, direction, maxDelay } = props;
  const videoRef = useRef<any>(null);
  const needReconnectCountRef = useRef(0);
  const reconnectIntervalRef = useRef<any>(null);
  const delayIntervalRef = useRef<any>(null);
  const lastResultRef = useRef<any>(null);
  const _RTCRef = useRef<any>(null);
  const [delayTime, setDelayTime] = useState(0);
  const startPlay = () => {
    if (!videoUrl) {
      return;
    }
    const win = window as any;
    _RTCRef.current = new win.SrsRtcPlayerAsync();
    _RTCRef.current.ontrack = function (event: any) {
      event.streams?.forEach((stream: any) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      });
      getRtcTimeStamp();
      reconnectIntervalRef.current = setInterval(() => {
        _RTCRef.current?.pc?.getStats(null).then((stats: any) => {
          const arr: any = [];
          stats.forEach((report: any) => {
            // 接收端码率为0时认为连接断开，需重连
            if (report.bytesReceived === 0) {
              arr.push(report.type);
            }
            if (report.type == 'inbound-rtp' && report.kind === 'video') {
              if (report.isRemote) {
                return;
              }

              const now = report.timestamp;
              const bytesReceived = report.bytesReceived;
              const reportId = report.id;
              if (
                lastResultRef.current &&
                lastResultRef.current.get(reportId)
              ) {
                const lastResult = lastResultRef.current.get(reportId);
                const bitrate =
                  (8 * (bytesReceived - lastResult.bytesReceived)) /
                  (now - lastResult.timestamp);
                if (bitrate == 0) {
                  needReconnectCountRef.current++;
                  if (needReconnectCountRef.current > 4) {
                    // 连续5次码率为0，重新连接
                    _RTCRef.current && _RTCRef.current.close();
                    clearInterval(reconnectIntervalRef.current);
                    startPlay();
                    needReconnectCountRef.current = 0;
                  }
                } else {
                  needReconnectCountRef.current = 0;
                }
              }
            }
          });
          lastResultRef.current = stats;
        });
      }, 5000);
    };
    _RTCRef.current &&
      _RTCRef.current
        ?.play(videoUrl)
        .then((res: any) => {})
        .catch((e: any) => {
          _RTCRef.current && _RTCRef.current.close();
          const timer = setTimeout(() => {
            clearTimeout(timer);
            startPlay();
          }, 1000);
        });

    const interval = setInterval(() => {
      if (videoRef.current) {
        clearInterval(interval);
        videoRef.current &&
          videoRef.current
            ?.play()
            .then((res: any) => {})
            .catch((e: any) => {});
      }
    }, 10);
  };

  const getRtcTimeStamp = () => {
    delayIntervalRef.current = setInterval(() => {
      if (videoRef.current && videoRef.current.requestVideoFrameCallback) {
        videoRef.current?.requestVideoFrameCallback(
          (timestamp: number, frame: any) => {
            const delay: any = formatTimeStamp(frame.rtpTimestamp) / 1000;
            setDelayTime(delay.toFixed(2));
            handleRecordDelayValue &&
              handleRecordDelayValue(delay.toFixed(3), direction, timestamp);
          }
        );
      }
    }, 500);
  };

  const formatTimeStamp = (rtcTimeStamp: any) => {
    const time = new Date();
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const date = time.getDate();
    if (rtcTimeStamp === 0) {
      return 0;
    }
    const now = Date.now();
    const time1 = new Date(
      year + '-' + month + '-' + date + ' 00:00:00'
    ).getTime();
    const t1 = now - time1;
    if (t1 >= 47721859) {
      rtcTimeStamp = rtcTimeStamp + 4294967295;
    }
    const t2 = Date.now() - (Math.floor(rtcTimeStamp / 90) + time1);
    return t2;
  };

  useEffect(() => {
    startPlay();
    return () => {
      _RTCRef.current && _RTCRef.current.close();
      _RTCRef.current = null;
      delayIntervalRef.current && clearInterval(delayIntervalRef.current);
      reconnectIntervalRef.current &&
        clearInterval(reconnectIntervalRef.current);
      reconnectIntervalRef.current = null;
      delayIntervalRef.current = null;
    };
  }, []);
  return (
    <div>
      <video className="rtc_media_player" ref={videoRef} autoPlay muted></video>
      <span
        className="cbox vbox delay-time"
        style={{
          display: `${delayTime > (maxDelay || 1) ? 'flex' : 'none'}`,
        }}
      >
        <img src={delay}></img>
        <span>延时：{delayTime}s</span>
      </span>
    </div>
  );
};

export default React.memo(RtcPlayer);
